
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M50.9 36.315H50c-1.1-3.4-4.5-7.8-8.8-8.2l2.2-14c.1-.5-.3-1.1-.8-1.1-.5-.1-1.1.3-1.1.8l-2 12.9c-.6-.6-1.5-1.2-2.6-1.4l.5-9c0-.6-.4-1-.9-1.1-.5 0-1 .4-1.1.9l-.5 9.1c-1.1.2-2 .8-2.7 1.6-.6.8-1 1.7-1 2.7-.7.1-1.4.4-1.9.8-1.2-1.9-3.3-3.1-5.6-3.1-2.1 0-4.1 1.1-5.4 2.8-1.3.3-2.3 1.2-2.9 2.4-2.2.1-4 1.7-4.6 3.8H10c-.6 0-1 .4-1 1v.9c0 4.5 3.7 8.2 8.2 8.2h26.4c4.5 0 8.2-3.7 8.2-8.2v-.9c.1-.5-.4-.9-.9-.9zm-10-6.2c3.1.2 5.8 3.4 7 6.1h-3v-.1c-.1-2.1-1.7-3.8-3.7-3.8-.2 0-.5 0-.7.1l.4-2.3zm-4.3-2.8c1.1.3 1.8 1.2 2.3 2.2l-.5 3.3c-.7-.1-1.5 0-2.1.4l.3-5.9zm-1.4 8c.2.2.5.3.8.3.3 0 .6-.2.8-.4.4-.6 1.3-.7 1.9-.3.1.1.2.1.4.2h.2c.3 0 .6-.1.8-.3.3-.3.7-.5 1.2-.5.9 0 1.7.8 1.7 1.8v.1H31.8v-.3c0-.7.8-1.3 1.8-1.3.7.1 1.3.4 1.6.7zm-19.2-.8c.5.1 1-.3 1.1-.8.2-1 .9-1.7 1.8-1.8.3 0 .6-.2.8-.5.8-1.4 2.3-2.2 3.9-2.2 1.9 0 3.7 1.2 4.3 3 .1.3.4.6.8.7.4.1.7-.1.9-.4.5-.7 1.5-1.1 2.6-1.1.3 0 .6-.1.8-.4.2-.3.3-.5.2-.8-.2-.9 0-1.6.4-2.2.3-.3.6-.6 1-.7l-.3 5.4c-.2 0-.5-.1-.7-.1-2.1 0-3.8 1.5-3.8 3.3v.2H12.9c.6-1 1.8-1.8 3.1-1.6zm27.7 9.9H17.2c-3.4 0-6.1-2.7-6.2-6.1h38.9c-.1 3.3-2.8 6.1-6.2 6.1z"}})])
          )
        }
      }
    